module.exports = __webpack_public_path__ + "img/images-03.b4223525.png";